import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { NavLink } from 'react-router-dom';
import Button from 'erpcore/components/Button';
import LayoutManager from 'erpcore/utils/LayoutManager';
import Listing from 'erpcore/components/Listing';
import PageHeader from 'erpcore/components/Layout/PageHeader';
import EventGuidelineDelete from 'erpcore/screens/Settings/EventGuidelines/components/EventGuidelineDelete';
import Svg from 'erpcore/components/Svg';
import TableActions from 'erpcore/components/Listing/components/TableActions';
import Tooltip from 'erpcore/components/Tooltip';

import { actions as listingActions } from 'erpcore/components/Listing/Listing.reducer';
import {
    getListingFetching,
    getListingResponse
} from 'erpcore/components/Listing/Listing.selectors';
import HeadMeta from 'erpcore/components/Layout/HeadMeta';

const EventGuidelines = () => {
    const title = 'Event Guidelines';
    const reducerName = 'guidelines';
    const actionName = 'GUIDELINES';

    const dispatch = useDispatch();

    const listing = useSelector(state => getListingResponse(state, reducerName));
    const listingFetching = useSelector(state => getListingFetching(state, reducerName));

    const fetchEventGuidelines = useCallback(params => {
        return new Promise((resolve, reject) => {
            dispatch({
                promise: { resolve, reject },
                type: listingActions.START_FETCHING_LISTING,
                params,
                entity: actionName,
                name: reducerName,
                endpoint: 'api/guidelines'
            });
        });
    }, []);

    const tableData = useCallback(() => {
        const table = {};
        table.data = [];

        // Table Schema
        table.schema = [
            {
                title: 'Guidelines Title',
                field: 'title',
                sortable: false
            },
            {
                title: 'Actions',
                field: 'actions'
            }
        ];

        table.defaultSort = {
            order: 'DESC',
            sortable: 'id'
        };

        // Table Data
        if (listing && listing.data) {
            listing.data.map(row => {
                return table.data.push({
                    id: row.id,
                    iri: row.iri,
                    title: row.title,
                    actions: (
                        <TableActions>
                            <TableActions.Action>
                                <Tooltip content="Edit event guideline">
                                    <NavLink to={`/settings/guidelines/${row.id}/edit`}>
                                        <Svg icon="edit" />
                                    </NavLink>
                                </Tooltip>
                            </TableActions.Action>
                            <TableActions.Action>
                                <EventGuidelineDelete
                                    guidelineData={row}
                                    form={`EventGuidelineDeleteForm-${row.iri}`}
                                />
                            </TableActions.Action>
                        </TableActions>
                    )
                });
            });
        }

        return table;
    }, [listing]);

    return (
        <LayoutManager slot="main" layoutType="merge">
            <HeadMeta title={title} />
            <PageHeader title={title}>
                <Button href="/settings/guidelines/create" label="Add new" />
            </PageHeader>

            <Listing
                name={reducerName}
                reducerName={reducerName}
                loading={listingFetching}
                meta={listing.meta}
                table={tableData()}
                onListingConfigUpdate={params => fetchEventGuidelines(params)}
            />
        </LayoutManager>
    );
};

export default EventGuidelines;
